import { ReactNode, createContext } from "react";
import useVendedor, { VendedorType, CreateVendedorType, EditVendedorType} from "./hooks/useVendedor";

interface VendedorContextProviderProps {
    children: ReactNode;
}

export interface VendedorContextData {
    createVendedor: (createVendedorData: CreateVendedorType) => Promise<CreateVendedorType | null>;
    getVendedorPaged: (
        pageNumber: number,
        Name?: string,
        EmpresaId?: number,
        pageSize?: number
    ) => Promise<VendedorType[] | null>;
    updateVendedor: (editVendedorData: EditVendedorType) => Promise<EditVendedorType | null>;
    deleteVendedor: (vendedorId: number) => Promise<VendedorType | null>;
    handleGetVendedorById: (vendedorId: number) => Promise<VendedorType | null>;
    setVendedor: any;
    vendedor: VendedorType;
    listVendedor: VendedorType[];
    initialListVendedor: VendedorType[];
    setListVendedor: (vendedor: VendedorType[]) => void;
    setPageCount: (count: number) => void;
    pageCount: number;
    handleGetVendedorByEmpresaId: (empresaId: number) => Promise<VendedorType[] | null>;
}

const initialState: VendedorContextData = {
    createVendedor: async () => null,
    getVendedorPaged: async () => null,
    updateVendedor: async () => null,
    deleteVendedor: async () => null,
    handleGetVendedorById: async () => null,
    setVendedor: () => {},
    vendedor: {
        id: 0,
        name: "",
    },
    listVendedor: [],
    initialListVendedor: [],
    setListVendedor: () => {},
    setPageCount: () => {},
    pageCount: 0,
    handleGetVendedorByEmpresaId: async () => null,
};

export const VendedorContext =
    createContext<VendedorContextData>(initialState);

export default function VendedorContextProvider({
    children,
}: VendedorContextProviderProps) {
    const {
        createVendedor,
        getVendedorPaged,
        updateVendedor,
        deleteVendedor,
        handleGetVendedorById,
        setVendedor,
        vendedor,
        listVendedor,
        initialListVendedor,
        setListVendedor,
        pageCount,
        setPageCount,
        handleGetVendedorByEmpresaId
    } = useVendedor();

    return (
        <VendedorContext.Provider
            value={{
                createVendedor,
                getVendedorPaged,
                updateVendedor,
                deleteVendedor,
                handleGetVendedorById,
                setVendedor,
                vendedor,
                listVendedor,
                initialListVendedor,
                setListVendedor,
                setPageCount,
                pageCount,
                handleGetVendedorByEmpresaId
            }}
        >
            {children}
        </VendedorContext.Provider>
    );
}
